module.exports = __webpack_public_path__ + "static/media/slider_5_master_user_es.81783996.svg";